import React from "react";
import ReactDOM from "react-dom/client";
import { registerSW } from "virtual:pwa-register";
import App from "./App.jsx";
import { initInstallPrompt } from "./pwa/installPrompt";
import "./index.css";

initInstallPrompt(); // must run before render
registerSW({ immediate: true }); // autoUpdate: the new SW takes over on its own

ReactDOM.createRoot(document.getElementById("root")).render(
     <App />
 );